import { render, staticRenderFns } from "./DocumentTemplateCreate.vue?vue&type=template&id=215f341e&scoped=true"
import script from "./DocumentTemplateCreate.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateCreate.vue?vue&type=script&lang=js"
import style0 from "./DocumentTemplateCreate.vue?vue&type=style&index=0&id=215f341e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215f341e",
  null
  
)

export default component.exports